import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["item", "panel"];

  connect() {
    // En mobile, quitar el active inicial del servidor — el usuario elige manualmente
    if (window.innerWidth <= 900) {
      this.itemTargets.forEach((i) => i.classList.remove("active"));
      this.panelTargets.forEach((p) => p.classList.remove("active"));
    }
  }

  filter(event) {
    const grade = event.currentTarget.dataset.grade;

    this.element.querySelectorAll(".alf-tab").forEach((tab) => {
      tab.classList.toggle("active", tab.dataset.grade === grade);
    });

    this.itemTargets.forEach((item) => {
      const show = grade === "all" || item.dataset.grade === grade;
      item.style.display = show ? "" : "none";
    });

    const firstVisible = this.itemTargets.find((item) => item.style.display !== "none");
    if (firstVisible) this._activateDesktop(firstVisible);
  }

  select(event) {
    if (window.innerWidth <= 900) {
      this._activateMobile(event.currentTarget);
    } else {
      this._activateDesktop(event.currentTarget);
    }
  }

  _activateDesktop(item) {
    const variety = item.dataset.variety;
    this.itemTargets.forEach((i) => i.classList.remove("active"));
    item.classList.add("active");
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("active", panel.dataset.variety === variety);
    });
  }

  _activateMobile(item) {
    const variety = item.dataset.variety;
    const isAlreadyActive = item.classList.contains("active");

    // Cerrar todo
    this.itemTargets.forEach((i) => i.classList.remove("active"));
    this.panelTargets.forEach((p) => p.classList.remove("active"));

    if (isAlreadyActive) return; // toggle cerrar

    item.classList.add("active");

    const panel = this.panelTargets.find((p) => p.dataset.variety === variety);
    if (panel) {
      item.insertAdjacentElement("afterend", panel);
      panel.classList.add("active");
    }
  }
}
